import React, { useEffect } from "react";

import Main from '../components/InvestmentPlans/Main'
import Beginner from "../components/InvestmentPlans/Beginner";
import Execute from "../components/InvestmentPlans/Execute";
import Exchange from "../components/InvestmentPlans/Exchange";
import SetUp from "../components/InvestmentPlans/SetUp";
import WhyChoose from "../components/InvestmentPlans/WhyChoose";
import Footer from "../components/Footer";

function InvestmentPlans () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[56px]">
            <Main/>
            <Beginner/>
            <Execute/>
            <Exchange/>
            <SetUp/>
            <WhyChoose/>
            <Footer titleKey="investment.49" />
        </div>
    );
}

export default InvestmentPlans;